import Vue from 'vue'
import 'babel-polyfill';

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import VueElementUISkeleton from 'vue-elementui-skeleton';
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'

import '@/styles/index.scss' // global css

import '@/styles/font-awesome/css/font-awesome.min.css'  //引入font-awesome

import App from './App'
import router from './router'
import store from './store'
import '@/utils/directives.js'

import { hasBtnPermission } from '@/utils/permission'


import '@/icons' // icon
import '@/permission' // permission control

// import Blob from '@/vendor/Blob.js'
// import Export2Excel from '@/vendor/Export2Excel.js'

import EleMultiCascader from "ele-multi-cascader"

import Print from 'vue-print-nb'

import Vue2OrgTree from 'vue2-org-tree'

import htmlToPdf from '@/plugins/htmlToPdf'

// import JsBarcode from 'jsbarcode';

// import VueResource from 'vue-resource'
// Vue.use(VueResource); 
// Vue.http.options.xhr = { withCredentials: true };
// Vue.http.options.emulateJSON = true; 
// Vue.http.options.crossOrigin = true; 
// Vue.http.interceptors.push(function(request, next) {
//   //拦截器 
//   // 跨域携带cookie 
//   request.credentials = true; next() }) 


//百度编辑器
// import VueUeditorWrap from 'vue-ueditor-wrap'
// Vue.component('vue-ueditor-wrap', VueUeditorWrap)



/* 路由发生变化修改页面title */
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})


router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});



//全局修改默认配置，点击空白处不能关闭弹窗
ElementUI.Dialog.props.closeOnClickModal.default = false

Vue.use(ElementUI, { locale })
Vue.use(VueElementUISkeleton, {
  directiveName: 'skeleton',
  rows: 10,
  radius: 3,
  bg: 'red'
});
Vue.use(VCharts)
Vue.use(EleMultiCascader)
Vue.use(Print);  //打印

Vue.use(Vue2OrgTree)
// Vue.use(JsBarcode);  //条形码
Vue.use(htmlToPdf)

Vue.prototype.hasPerm = hasBtnPermission;


Vue.prototype.HOST = '/api';
Vue.prototype.$platId = '6';//芸欣
// Vue.prototype.$platId = '1';//科欣
Vue.prototype.$source = 'system';
Vue.prototype.$weburl = 'https://www.51bencao.net/api/api/';  //导出2
Vue.prototype.$hosturl = 'https://www.51bencao.net/'; //404用户跳转首页
// Vue.prototype.$weburl = 'http://www.sckxyy.net:9009/api/api/',
// Vue.prototype.$hosturl = 'http://www.sckxyy.net:8081/',
// Vue.prototype.$hosturl = 'http://192.168.100.248:9000/';
// Vue.prototype.$weburl = 'http://192.168.100.248:9000/api/';
// Vue.prototype.$weburl = 'http://192.168.3.247:9000/';
// Vue.prototype.$weburl = 'http://125.64.43.138:9000/api/';
// Vue.prototype.$weburl = 'http://192.168.0.55:9000/api/';
// Vue.prototype.$downurl = 'http://125.64.43.130:10100/';
Vue.prototype.$downurl = 'https://www.51bencao.net/filedown/';
// Vue.prototype.$WebSocket='ws://222.211.65.10:8759/websocket/';

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js